import React, { Component } from 'react'
import { connect } from 'react-redux'

import * as R from 'ramda'

import LeftSide from './LeftSide'
import Deleted from 'components/Deleted'

import { doc, dirtyRead } from 'selectors/common'

import dataActions from 'actions/dataActions'

let select = dirtyRead(
	(state, props) => ({
		property: doc(state, props.propertyID )
	})
)

export class ExternalLinks extends Component{
	render(){
		let { props } = this
		let propertyID = props.propertyID
		let address = props.property.address || ""
		return(
			<div className="links" style={{textAlign:"center", marginTop:"20px"}}>
				<a
					href={
						(
							props.property.cors
							&& props.property.cors.lat
							&& props.property.cors.lng
						)?`http://www.greatschools.org/search/search.page?lat=${
								props.property.cors.lat
							}&lon=${
								props.property.cors.lng
							}&zipCode=${
								address.split(' ')[address.split(' ').length - 1]
							}&state=${
								address.split(' ')[address.split(' ').length - 2]
							}&locationType=street_address&normalizedAddress=${
								address.split(' ').join('%20')
							}&sortBy=DISTANCE&distance=5`
							:
							''
					}
					target="_blank"
					style={{
						display: 'inline-block'
					  , textAlign: 'center'
					  , margin: "0 30px"
					}}
					title = "Explore on Greatschools"
				>
					<img
						src={".." + "/static/img/logo_greatschool.png"}
						style={{
							maxWidth: '40px'
						}}
					/>
				</a>
				<a
					href={
						`http://www.zillow.com/homes/${address.split(' ').join('-')}_rb/?fromHomePage=true&shouldFireSellPageImplicitClaimGA=false`
					}
					target="_blank"
					style={{
						display: 'inline-block'
					  , textAlign: 'center'
					  , margin: "0 30px"
					}}
					title = "Explore on Zilow"
				>
					<img
						src={".." + "/static/img/logo_zillow.png"}
						style={{
							maxWidth: '40px'
						}}
					/>
				</a>
				<a
					href={`http://zipwho.com/?zip=${address.split(' ')[address.split(' ').length - 1]}&city=&filters=--_--_--_--&state=&mode=zip`}
					target="_blank"
					style={{
						display: 'inline-block'
					  , textAlign: 'center'
					  , margin: "0 30px"
					}}
					title = "Explore on Zipwho"
				>
					<img
						src={".." + "/static/img/logo_zipwho.png"}
						style={{
							maxWidth: '40px'
						}}

					/>
				</a>
			</div>
		)
	}
}

export default connect(select, R.mergeAll([dataActions]))(ExternalLinks)



// WEBPACK FOOTER //
// ./src/routes/manager/propertyForm/ExternalLinks.js